// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"Loading_loadingContainer__1U8ST","loadingShade":"Loading_loadingShade__2zQsb"};